import { useEffect, useState } from 'react';

interface SwipeSettings {
    ref: React.RefObject<HTMLElement>;
    onSwipeLeft: () => void;
    onSwipeRight: () => void;
    shouldDisableLeftNavigation?: boolean;
    shouldDisableRightNavigation?: boolean;
}

export const useSwipe = ({
    ref,
    onSwipeLeft,
    onSwipeRight,
    shouldDisableLeftNavigation = false,
    shouldDisableRightNavigation = false,
}: SwipeSettings) => {
    const [touchStart, setTouchStart] = useState(0);
    const minSwipeDistance = 50;

    useEffect(() => {
        const element = ref.current as HTMLElement;

        const handleTouch = (e: TouchEvent) => {
            switch (e.type) {
                case 'touchstart':
                    setTouchStart(e.changedTouches[0].pageX);
                    break;
                case 'touchend':
                    if (
                        Math.abs(e.changedTouches[0].pageX - touchStart) <
                        minSwipeDistance
                    ) {
                        break;
                    }
                    e.changedTouches[0].pageX < touchStart
                        ? !shouldDisableRightNavigation && onSwipeLeft()
                        : !shouldDisableLeftNavigation && onSwipeRight();
            }
        };

        element.addEventListener('touchstart', handleTouch);
        element.addEventListener('touchend', handleTouch);

        return () => {
            element.removeEventListener('touchstart', handleTouch);
            element.removeEventListener('touchend', handleTouch);
        };
    });
};
